export default function Switch() {
  return {
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          left: 0,
          right: 'auto'
        }
      }
    }
  };
}
